import * as React from 'react';

import pendo, { LEARNER_API_KEY } from 'js/lib/pendo';
import user from 'js/lib/user';

import { DISABLE_PENDO_ORGS } from 'bundles/enterprise-legacy-learner-home/constants/ProgramHomeConstants';
import SimpleCourseraMetatags from 'bundles/seo/components/SimpleCourseraMetatags';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/org-scoped/ThirdPartyOrganizationContext';

type Props = {
  children: React.ReactNode;
};

const OrganizationPageTrackingWrapper = ({ children }: Props) => {
  const thirdPartyOrg = useThirdPartyOrganization();
  const [isPendoInitialized, setIsPendoInitialized] = React.useState(false);

  React.useEffect(() => {
    if (!DISABLE_PENDO_ORGS.includes(thirdPartyOrg?.id || '') && !!thirdPartyOrg && !isPendoInitialized) {
      pendo.init(
        {
          visitor: user.isAuthenticatedUser()
            ? {
                id: user.get().external_id,
                isStaff: user.get().is_staff,
                isSuperuser: user.get().is_superuser,
                isCourserian: user.isCourserian(),
              }
            : {},
          account: {
            id: thirdPartyOrg.id ?? '',
            name: thirdPartyOrg.name ?? '',
            slug: thirdPartyOrg.slug ?? '',
            isEnterprise: true,
            isCareerAcademyV2: false,
          },
        },
        LEARNER_API_KEY
      );
      setIsPendoInitialized(true);
    }
  }, [thirdPartyOrg, isPendoInitialized]);

  return (
    <React.Fragment>
      {children}
      <SimpleCourseraMetatags disableCrawlerIndexing title={thirdPartyOrg?.name} />
    </React.Fragment>
  );
};

export default OrganizationPageTrackingWrapper;
